module.exports = __webpack_public_path__ + "static/media/brycen1.619219f5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen1.gif
// module id = 146
// module chunks = 0